/**
 * 碳排放量計算
 * @param {number} weightKg - 公斤
 * @param {number} distanceKm - 公里
 * @param {number} factor - 碳係數 || null
 * @returns {Number}
 */
export const calcCO2Emission = (weightKg, distanceKm, factor = 0.683) => {
    const tons = weightKg / 1000; // 公斤轉公噸
    const emission = tons * distanceKm * factor;
    return Number(emission.toFixed(2)); // 四捨五入
}